import React from "react";
import clsx from "clsx";
import CurrencyInput from "../../CurrencyInput/CurrencyInput";
import NumberInput from "../../NumberInput/NumberInput";
import DateHelper from "../../DateHelper/DateHelper";
import DatePickerInput from "../../DatePickerInput/DatePickerInput";
import RoomTypePriceBuilderErrors from "../RoomTypePriceBuilderErrors";
import { format } from "date-fns";

class RoomTypePriceBuilderGeneral extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      numberFormat:
        "0" +
        ($("#delimiter").val() || ",") +
        "0" +
        ($("#separator").val() || ".") +
        "00",
      dateFormat: DateHelper.rubyToDateJS(this.props.date_format),
      timeFormat: DateHelper.rubyToDateJS(this.props.time_format),
    };
  }

  renderErrors() {
    var errors = RoomTypePriceBuilderErrors.general(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => {
        idx = idx + 1;
        return (
          <li key={idx}>
            <b>&#x2022;</b> {error}
          </li>
        );
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldClasses(field, classnames) {
    var classname = classnames || "form-control";
    if (
      this.props.errors &&
      Object.keys(this.props.errors).length &&
      this.props.errors[field]
    ) {
      classname = classname + " has-errors";
    }
    return classname;
  }

  renderFieldName(field) {
    if (this.props.nested) {
      return "room_type_price_attributes[" + field + "]";
    } else {
      return field;
    }
  }

  render() {
    
    var tabClasses = clsx({
      active: this.props.active_tab == "general",
      "tab-pane": true,
    });
    var days_of_week = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];
    var days = days_of_week.map((day_of_week) =>
      this.renderDayOfWeek(day_of_week)
    );
    var base_price = days_of_week.map((day_of_week) =>
      this.renderBasePrice(day_of_week)
    );

    var min_stay = days_of_week.map((day_of_week) =>
      this.renderDailyMinimumStay(day_of_week)
    );
    
    return (
      <div className={tabClasses} id="general">
        {this.renderErrors()}
        <div className="row" style={{ marginBottom: 20 }}>
          {this.renderRoomType()}
        </div>
        <div className="container-fluid" style={{ overflowX: "scroll" }}>
          <div className="row">
            <div
              className="col-md-2"
              style={{ width: "12%", marginRight: "20px" }}
            >
              <div className="form-group">
                <label>
                  {I18n.t("start_date")}{" "}
                  <span
                    className="ss-help help"
                    title={I18n.t("room_type_price_date_helper_text")}
                  ></span>
                </label>
                {!this.props.read_only && this.props.new_record === true ? (
                  <DatePickerInput
                    selectedDate={this.props.start_date}
                    dateFormat={this.state.dateFormat}
                    onChange={this.props.onChangeStartDate}
                  />
                ) : (
                  <div>
                    {format(this.props.start_date, this.state.dateFormat)}
                  </div>
                )}
                {this.renderFieldErrors("start_date")}
              </div>
            </div>
          </div>
          <br />
          <div className="row" style={{ minWidth: "800px" }}>
            <div
              className="col-md-1 col-sm-1 col-xs-1"
              style={{ width: "12%", marginRight: "20px" }}
            >
              <label>{I18n.t("default")}</label>
            </div>
            {days}
          </div>
          <div className="row" style={{ marginTop: "10px", minWidth: "800px" }}>
            <div
              className="col-md-1 col-sm-1 col-xs-1"
              style={{ width: "12%", marginRight: "20px" }}
            >
              <label>{I18n.t("base_price")}</label>
            </div>
            {base_price}
          </div>

          {
            this.props.room_type && this.props.room_type.type_of_booking === "daily" || this.props.daily_rental === true
              ? 
            null 
              : 

            <div className="row" style={{ marginTop: "10px", minWidth: "800px" }}>
              <div className="col-md-1 col-sm-1 col-xs-1" style={{ width: "12%", marginRight: "20px" }}>
                <label style={{ whiteSpace: "nowrap" }}>
                  {I18n.t("minimum_stay")}
                </label>
              </div>
              {min_stay}
            </div>
          }


        </div>
      </div>
    );
  }

  renderRoomType() {
    if (
      this.props.view_type === "room_type_price" ||
      this.props.view_type === "group_contract_price"
    ) {
      return (
        <div>
          <div className="col-md-10">
            <label>{I18n.t("room_type")}</label>
            <div>{this.props.room_type.name}</div>
          </div>
        </div>
      );
    }
  }

  renderDayOfWeek(day_of_week) {
    return (
      <div className="col" key={day_of_week}>
        <label>{I18n.t(day_of_week)}</label>
      </div>
    );
  }

  renderDailyMinimumStay(day_of_week) {
    var self = this;
    var min_stay_name = day_of_week + "_minimum_stay";

    return (
      <div className="col" key={day_of_week}>
        <div>
          {!this.props.read_only ? (
            <div>
              <div
                className={this.renderFieldClasses(
                  min_stay_name,
                  "input-group"
                )}
              >
                <NumberInput
                  className="form-control"
                  name={this.renderFieldName(min_stay_name)}
                  onChange={this.props.onChange}
                  value={this.props[min_stay_name]}
                />
              </div>
              {this.renderFieldErrors(min_stay_name)}
              {day_of_week == "sunday" ? (
                <div className="form-group">
                  <a
                    className="primary"
                    style={{ cursor: "pointer" }}
                    onClick={(e) =>
                      self.props.onChangeAllMinimumStays(
                        self.props.sunday_minimum_stay,
                        self.props.roomTypeId
                      )
                    }
                  >
                    {I18n.t("apply_to_all")}
                  </a>
                </div>
              ) : null}
            </div>
          ) : (
            <div>
              {this.props[min_stay_name] ? (
                <span>
                  {this.props[min_stay_name]} {I18n.t("nights")}
                </span>
              ) : (
                <em>{I18n.t("none")}</em>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }

  renderBasePrice(day_of_week) {
    var self = this;
    var base_price = day_of_week + "_amount";
    return (
      <div className="col" key={base_price}>
        {!this.props.read_only ? (
          <div>
            <div>
              <CurrencyInput
                className={this.renderFieldClasses(base_price)}
                cents={false}
                name={this.renderFieldName(base_price)}
                onChange={this.props.onChange}
                value={this.props[base_price]}
                onChangeEventType={true}
              />
            </div>
            {this.renderFieldErrors(base_price)}

            {day_of_week == "sunday" ? (
              <div className="form-group">
                <a
                  className="primary"
                  style={{ cursor: "pointer" }}
                  onClick={(e) =>
                    self.props.onChangeAllDays(
                      self.props.sunday_amount,
                      self.props.roomTypeId
                    )
                  }
                >
                  {I18n.t("apply_to_all")}
                </a>
              </div>
            ) : null}
          </div>
        ) : (
          <div>
            {this.props[base_price] ? (
              <span>
                {" "}
                <em>
                  {I18n.t("number.currency.format.unit")}
                  {(this.props[base_price] / 100).toFixed(2)}
                </em>
              </span>
            ) : (
              <em>{I18n.t("none")}</em>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default RoomTypePriceBuilderGeneral;
